import { ReviewsListProps } from '../types';
import ReviewColumn from './ReviewsColumn';
import { Box } from '@wix/design-system';
import clsx from 'clsx';
import defaultStyles from './ReviewsList.module.scss';

const ReviewsList = ({
  reviews,
  className,
  gridProps,
  ...restProps
}: ReviewsListProps) => {
  const {
    numberOfColumns = 1,
    visibleAmount = reviews?.length,
    className: gridClassName,
    styles,
  } = gridProps || {};

  const reviewsPerColumn = Math.ceil(visibleAmount / numberOfColumns);

  const styleClasses = styles || defaultStyles;

  const containerClassName = clsx(
    styleClasses.reviewsList,
    numberOfColumns > 1 ? styleClasses.multiColumn : styleClasses.singleColumn,
    gridClassName,
  );

  const columnClassName =
    numberOfColumns === 1
      ? styleClasses?.singleColumn || ''
      : styleClasses?.reviewColumn || ''; // Use reviewColumn from type interface

  return (
    <Box className={containerClassName}>
      {Array.from({ length: numberOfColumns }, (_, index) => {
        return (
          <ReviewColumn
            key={index}
            reviews={reviews}
            {...restProps}
            startIndex={index * reviewsPerColumn}
            endIndex={index * reviewsPerColumn + reviewsPerColumn}
            className={columnClassName || className}
          />
        );
      })}
    </Box>
  );
};

export default ReviewsList;
